module.exports = __webpack_public_path__ + "static/media/modal_sign_right_k.58c26725.png";